import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  user = null;
  firstRoute = '';

  constructor(private login: LoginService, private router: Router) {
    this.login.getLogIn().subscribe(user => { 
      this.user = user;
      // this.user.permissoes = {
      //   ...this.user.permissoes,
      //   auditoria_associarunidades: true,
      //   auditoria_configlaudo: true
      // }
      this.firstRoute = user ? this.setFirstRoute() : '';
    });
  }

  setFirstRoute() {
    let route = '';
    this.router.config.forEach( config => {
      if(config.children && config.children.length > 0 ) {
        let permissoes = this.user ? this.user.permissoes : [];
        let childRoute = config.children.find( c => {
          let permissaoRota = c.data && c.data.permissao ? c.data.permissao : '';
          return permissoes[permissaoRota] || false;
        });
        if(childRoute && !route) {
          route = [config.path, childRoute.path].join('/');
        }
      }
    })
    return route;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | UrlTree {
    if(route.url.length == 0 || (route.url.length>0 && route.url[0].path == '')) {
      if(this.user) {
        return this.router.parseUrl('/' + this.firstRoute);
      } else {
        return true;
      }
    }
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean | UrlTree {
    let permissoes = this.user ? this.user.permissoes : [];
    if(route.data && !route.data.permissao) {
      return true;
    } else if (route.data && route.data.permissao && permissoes[route.data.permissao]) {
      return true;
    } else {
      return this.router.parseUrl('/erro');
    }
  }

}